import type { Container } from 'pixi.js';
import type { GameAreaView } from '../GameAreaView';
import type { BoardModel } from '../models/board/BoardModel';
import type { LevelData } from '../../level/LevelData';
import { GameTutorialController } from '../../tutorials/game/GameTutorialController';
import { GameTutorialModel } from '../../tutorials/game/GameTutorialModel';
import { GameTutorialView } from '../../tutorials/game/GameTutorialView';
import type { TopBarView } from '../../views/TopBarView';
import type { BoosterType } from '../../boosters/types';
import type { BlockerIntroType } from '../../blockers/constants';

export function initTutorial(
  gameAreaView: GameAreaView,
  boardModel: BoardModel,
  levelData: LevelData,
  overlay: Container,
  topBarView: TopBarView,
  openBoosterPopup: (boosterType: BoosterType, collect: boolean) => Promise<void>,
  useBooster: (boosterType: BoosterType) => Promise<void>,
  openBlockerPopup: (blockerType: BlockerIntroType) => Promise<void>,
): GameTutorialController {
  const tutorialState = levelData.tutorial;
  if (!tutorialState) {
    throw new Error('Level should have tutorial state!');
  }
  const tutorialModel = new GameTutorialModel(tutorialState);
  const tutorialView = new GameTutorialView({
    overlay,
    topBarView,
    gameAreaView,
  });

  gameAreaView.boardView.once('destroyed', () => {
    tutorialView.destroy();
  });

  return new GameTutorialController({
    boardModel,
    model: tutorialModel,
    view: tutorialView,
    openBoosterPopup,
    useBooster,
    openBlockerPopup,
  });
}
